import React, { useState, useEffect } from "react";
import styled from "styled-components";
import logo2 from "./logo2.jpg";
import { MultiStepForm, Step } from "react-multi-form";
import { Button, FormGroup,Col, Row, Label, Input } from "reactstrap";
import Forms from "./Forms.js";
import Parte1 from "./parte1.js";
import Parte2 from "./parte2.js";
import axios from "./axios-config";
import swal from "./i18n/swal";
import $ from "jquery";
import LoadingOverlay from "react-loading-overlay";
import BounceLoader from "react-spinners/RingLoader";
import Moment from "moment";
import "moment/locale/es";
import { Modal } from "react-bootstrap";
import { FaPlus, FaWhatsapp } from "react-icons/fa";
import loader from "./pageLoader.gif";
import Bitacora from "./tabATOnly.js";
import Carusel from "./carusel.js";
import Drop from "./dropzoneSingle.js";
import { Encriptar } from "./Util/Encripcion";
import { FileText } from "lucide-react";
import Tabs from "./tab0.js";
import DescargarDoc from "./Liquidacion/DescargarDoc.js"
import DocPendientes from "./DocPendientes.js";
import { useIdioma } from "./context/IdiomaContext";
const Container = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  @media (max-width: 590px) {
    width: 300px;
  }
`;

const General = (props) => {
  const { t } = useIdioma();
  const [showModal5, setShowModal5] = useState(false);
  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);
  const [modalInfo1, setModalInfo1] = useState([]);
  const [datoAsesor, setdatoAsesor] = useState([]);
  const [files, setFiles] = useState([]);
  const [mostrarModalLiq,setMostrarModalLiq]=useState(false);
  const [noCheqTrans,setNoCheqTrans]=useState("");
  const [dirigidaA,setDirigidaA]=useState("");
  const [fechaLiquidacion,setFechaLiquidacion]=useState("");
  const [tipoGestion, setTipoGestion] = useState(null);
 const [ultimoEstado, setUltimoEstado] = useState(null);
 const handleDatosBitacora = (datos) => {
  setTipoGestion(datos.tipoGestion);
  setUltimoEstado(datos.ultimoEstado);
};
 // obtenemos la version del sitio
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getParametrosGeneralesAPP/VERSION-APP`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        if (json.status == 200) {
          let version = json.data.ParametrosAppSomit.find(
            (item) => item.nombreParametro.toLowerCase() === "version-reclamos"
          ).valorParametro;

          props.onSetVersion(version ? "v"+version : "");
        }
      });
  }, []);

  const enviar_contacto = () => {
    return window.open("https://wa.me/502" + sessionStorage.getItem("datosAsesor"));
  };
 const cerrarModalLiq = () => {     
    setMostrarModalLiq(false);
  };
 
  const handleVerLiq = (ID_GESTION) => {    
      axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/liquidacionReclamo/` +
              ID_GESTION,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){
            /*dat = json.data;
            setModalInfo2(row);
            setModalInfo3(json.data.dirigidoA);
            setModalInfo4(json.data.numeroCheque);
            window.rectab = row;*/
            setDirigidaA(json.data.liqidacionReclamo.dirigidoA);
            setNoCheqTrans(json.data.liqidacionReclamo.numeroChequeTrans);
            setFechaLiquidacion( Moment(json.data.liqidacionReclamo.fechaLiquidacion).format("L"));
            
            }
          });
        /*axios
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/liq_bitacora/` +
              ID_GESTION,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((json) => {
            if(json.status==200){          
            setFechaLiquidacion( Moment(json.data.tRecLogUsuario[0].fechaLog).format("L"));
            }
          });
          */



        /*setModalInfo2(row);
        setModalInfo3(dat.dirigidoA);
        setModalInfo4(dat.numeroCheque);
        //setModalInfo5(dat.tRecLogUsuario.log);
        window.rectab = row;
        toogleTrueFalse2();    */

        setMostrarModalLiq(true);
  }


  const ModalContentLiq = ({show,onClose}) => {
      return (
        <Modal
          size="xl"
          style={{ maxWidth: "1600px", width: "100%" }}
          show={show}
          onHide={onClose}         
        >
          <Modal.Header
            style={{ background: "rgb(135, 36, 52)", color: "white" }}          
            closeButton
            closeVariant="white"         
          >
            <Modal.Title>Liquidación de Reclamo No: {window.rectab}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <strong>Detalle Liquidacion</strong>
            <hr style={{ background: "#872434", size: 5, color: "#872434" }} />
            <FormGroup row>
              <Col md="4">
                <Label>
                  {" "}
                  <strong>Numero de Cheque / Transferencia:</strong>
                </Label>
  
                <Input value={noCheqTrans} disabled />
              </Col>
              <Col md="4">
                <Label>
                  <strong>Dirigido a:</strong>
                </Label>
  
                <Input value={dirigidaA} disabled />
              </Col>
              <Col md="4">
                <Label>
                  <strong>Fecha Liquidación:</strong>
                </Label>
  
                <Input value={fechaLiquidacion} disabled />
              </Col>
              {/*<Col md="12">
                <Label>
                  <strong>Observaciones Liquidacion:</strong>
                </Label>
              </Col>
              <Col md="12">
                <Input rows="8" type="textarea" value={modalInfo5} disabled />
              </Col>*/}
            </FormGroup>
  
            <Tabs />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      );
    };
 

  const Digitalizar = (valor) => {
    var element = document.getElementById("drop");
    var estado = element.style.display;
    if (estado == "none") {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  };

  const Generar = () => {
    //console.log(window.datoArchivoN);
    //console.log(modalInfo1.ID);
    setFiles(window.datoArchivoN);
    ////console.log(files);

    //custom-file-input
    const formData = new FormData();
    ////console.log(window.miVariable);
    // Update the formData object
    if (window.miVariable) {
      //console.log("window.miVariable.: ", window.miVariable);
      formData.append(
        "codigo_aseguradora",
        window.miVariable.tPolCertificado.idPoliza.idAseguradora.idAseguradora
      );
      formData.append(
        "codigo_tipo_poliza",
        window.miVariable.tPolCertificado.idPoliza.idTipoPoliza.codigoTipoPoliza
      );
      formData.append(
        "numero_poliza",
        window.miVariable.tPolCertificado.idPoliza.numero_poliza
      );
      formData.append("id_reclamo", modalInfo1.ID);
      formData.append("rec_id_pais", 1);
      formData.append("operacion", 9);
    }
    for (var i = 0; i < files[0].length; i++) {
      //console.log(i);
      //console.log(files[i]);
      //console.log(files[0][i].name);
      formData.append("archivos[]", files[0][i], files[0][i].name);
    }

    var data = formData;
    //console.log(data);
    var url = `${process.env.REACT_APP_API_URL}/Gestion_Reclamo`;
    $.ajax({
      type: "POST",
      url: url,
      enctype: "multipart/form-data",
      processData: false,
      contentType: false,
      cache: false,
      data: data,
      success: function (digita) {
        var res = eval(digita);
        if (res[0] === "false") {
          swal(
            {
              title: "Somit Regional",
              text: "No fue posible digitalizar, su sesión ha finalizado, vuelva a ingresar por favor.",
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#7c211e",
              confirmButtonClass: "btn-danger",
              confirmButtonText: "aceptar",
              closeOnConfirm: true,
              closeOnCancel: false,
            },
            function (isConfirm) {}
          );
        } else {
          var result = "";
          for (var i = 0; i < res.length; i++) {
            result = result + res[i] + "\n";
          }
          //                  swal('Somit Regional', result, 'warning');
        }
      },
      complete: function () {
        //console.log(modalInfo1);

        swal(
          "Exitoso",
          "Se ha cargado tu información correctamente y notificado al asesor de tu reclamo",
          "success"
        );
      },
      error: function (digita) {},
    });

    return false;
  };

  let validacion = 0;
  const validar = () => {
    $("#dpi").css("border-color", "#ced4da");
    $("#dpi").find("span").remove();
    $("#fecha").css("border-color", "#ced4da");
    $("#fecha").find("span").remove();
    if ($("#dpi").val().length === 0 && $("#fecha").val().length === 0) {
      $("#dpi").css("border-color", "#C70039");
      $("#dpi").after("<span class='mensaje-validacion'><strong>Campo Vacio</strong></span>");
      $("#fecha").css("border-color", "#C70039");
      $("#fecha").after("<span class='mensaje-validacion'><strong>Campo Vacio</strong></span>");
      validacion = 0;
    } else if ($("#dpi").val().length === 0 && $("#fecha").val().length !== 0) {
      $("#dpi").css("border-color", "#C70039");
      $("#dpi").after("<span class='mensaje-validacion'><strong>Campo Vacio</strong></span>");
      $("#fecha").css("border-color", "#ced4da");
      $("#fecha").find("span").remove();
      validacion = 0;
    } else if ($("#dpi").val().length !== 0 && $("#fecha").val().length === 0) {
      $("#fecha").css("border-color", "#C70039");
      $("#fecha").after("<span class='mensaje-validacion'><strong>Campo Vacio</strong></span>");
      $("#dpi").css("border-color", "#ced4da");
      $("#dpi").find("span").remove();
      validacion = 0;
    } else {
      validacion = 1;
      $("#dpi").css("border-color", "#ced4da");
      $("#dpi").find("span").remove();
      $("#fecha").css("border-color", "#ced4da");
      $("#fecha").find("span").remove();
    }
    return validacion;
  };

  const toogleTrueFalse5 = () => {
    setShowModal5(handleShow5);
  };

  const ModalContentBit = () => {
    $("#drop").hide();
    return (
      <Modal
        size="xl"
        style={{ maxWidth: "1600px", width: "100%" }}
        show={show5}
        onHide={handleClose5}
      >
        <Modal.Header
          style={{ background: "#003479", color: "white" }}
          closeButton
        >
          <Modal.Title>Gestión No: {modalInfo1}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>           
            <Row>
            {/*Reclamos*/tipoGestion === 1 && /*estado cerrado, anulado*/ ![4,-1].includes(ultimoEstado) && (
              <Button
                onClick={() => Digitalizar(modalInfo1)}
                style={{
                  background: "#872434",
                  color: "#ffffff",
                  cursor: "pointer",
                  marginLeft: "20px"
                }}
              >
                <FaPlus /> Añadir archivos
              </Button>
            )}
            
             {/*Autorizaciones*/tipoGestion === 2 && /*estado cerrado, anulado*/ ![3,4].includes(ultimoEstado) && (
              <Button
                onClick={() => Digitalizar(modalInfo1)}
                style={{
                  background: "#872434",
                  color: "#ffffff",
                  cursor: "pointer",
                  marginLeft: "20px"
                }}
              >
                <FaPlus /> Añadir archivos
              </Button>
            )}

              <Col md={5}>
                <Button
                  onClick={() => enviar_contacto()}
                  style={{ cursor: "pointer", backgroundColor:"rgb(57 155 57)" }}
                  id="cont_reclamo"
                  name="cont_reclamo"
                  
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp size={25} />
                  &nbsp;Asesor
                </Button>
              </Col>
              <Col md={tipoGestion == 1?3:5} className="text-right">
                {tipoGestion == 1 /* reclamo */
                  ?/*Estados liquidado y cerrado*/ [3,4].includes(ultimoEstado) && (
                      <DescargarDoc
                        numeroGestion={window.rectab}
                        tipoGestion="1"
                        titulo="Descargar Liquidación"
                      />
                    )
                  : ultimoEstado == 3 && ( /* Autorizacion*/
                      <DescargarDoc
                        numeroGestion={window.rectab}
                        tipoGestion="2"
                        titulo="Descargar Autorización"
                      />
                    )}
              </Col>
              <Col md={2} className="text-right">
                {
                  /*Cuando se va a traer la bitacora  el api devuelve un atributo ultimo estado, si es 4 significa que esta cerrad o finalizado y 3 liquidado */
                  /*Si es autorizacion no mustra la opcion descargar liquidacion
                  tipoGestion=2 significa que es autorizacion
                  */
                  tipoGestion == 2
                    ? ""
                    :/*Estado liquidado, cerrado */ [3,4].includes(ultimoEstado) && (
                        <div>
                          <Button
                            onClick={() => handleVerLiq(window.rectab)}
                            style={{ background: "#872434", color: "#ffffff" }}
                          >
                            <FileText size={16} className="me-2" /> Ver
                            Liquidación
                          </Button>
                        </div>
                      )
                }
              </Col>
            </Row>
          </div>

          <br></br>
          <div id="drop" name="drop" style={{ display: "none" }}>
            <DocPendientes numeroGestion={modalInfo1} tipoGestion={tipoGestion}/>
            <br></br>
          </div>
          <br></br>
          <Bitacora onDatosListos={handleDatosBitacora} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  };
  const hideComponentn = (name) => {
    //  this.toggle();
    switch (name) {
      case "showHideDemo1":
        window.showHideDemo1 = true;
        window.showHideDemo2 = false;
        window.showHideDemo3 = false;

        // this.setState({ showHideDemo1: !this.state.showHideDemo1 });
        break;
      case "showHideDemo2":
        //console.log("muestra el 2");
        window.showHideDemo1 = false;
        window.showHideDemo2 = true;
        window.showHideDemo3 = false;
        //this.setState({ showHideDemo2: !this.state.showHideDemo2 });
        break;
      case "showHideDemo5":
        //console.log("muestra el 2");
        window.showHideDemo1 = false;
        window.showHideDemo2 = false;
        window.showHideDemo3 = true;
        //this.setState({ showHideDemo2: !this.state.showHideDemo2 });
        break;
    }
  };

  const agregar_spinner_regional = (id_objeto) => {
    //console.log("llegue" + id_objeto);

    $("#" + id_objeto).addClass("overlay");
    $("#" + id_objeto).show();
  };

  const limpiar_spinner = (id_objeto) => {
    //console.log("ingrese a limpieza" + id_objeto);
    $("#" + id_objeto).removeClass("overlay");
    $("#" + id_objeto).html("");
    $("#" + id_objeto).hide();
  };

  const GetInfo = async () => {
    agregar_spinner_regional("dv_gmrec_blockgeneral");

    hideComponentn(window.consultar);
    //console.log("window.consultar ",window.consultar);
    let valor = validar();
    let valorValidado = 0;
    let valorValidadoNo = 0;
    if (valor === 1) {
      swal(
        "Se estan consultando tus datos de ingreso, por favor espera un momento, al momento de cargar cambiará de pantala",
        {
          buttons: false,
          timer: 5000,
        }
      );
      let datos = {
        dpi: $("#dpi").val(),
        fechaNacimiento: $("#fecha").val(),
      };
      let datosEncriptados = await Encriptar(JSON.stringify(datos));
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
        transformRequest: [(data) => data],
      };
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/loginrec1`,
          datosEncriptados,
          axiosConfig
        )
        .then((json) => {
          if (json.status === 200) {
            window.miVariable = json.data;
            sessionStorage.setItem("jwtToken", json.data.token);
            ///aqui voy a traer los estados para mostrar en la grafica
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getEstadoRecAutori`,
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem(
                      "jwtToken"
                    )}`,
                  },
                }
              )
              .then((respuestaApi) => {
                const data = respuestaApi.data.EstadoRecAutori;                
                const estadosAutorizacion = data.estadosAutorizacion;
                const estadosReclamos = data.estadosReclamos;
                const estadosAutoriFiltados = estadosAutorizacion.filter(
                  (e) => e.mostrarGrafica === 1
                );
                const estadosReclamosFiltrado = estadosReclamos.filter(
                  (e) => e.mostrarGrafica === 1
                );
                 window.estadosReclamos = estadosReclamosFiltrado;
                 window.estadosAutorizacion = estadosAutoriFiltados;
              });
            limpiar_spinner("dv_gmrec_blockgeneral");
            $("#caso .mensaje-validacion").remove();
            $("#dpi").find("span").remove();
            $("#dpi").css("border-color", "#ced4da");
            $("#dpi").find("span").remove();
            $("#fecha").css("border-color", "#ced4da");
            $("#fecha").find("span").remove();
            if (window.consultar == "showHideDemo1") {
              if (json.data.tPolCertificado.length >= 0) {
                for (var i = 0; i < json.data.tPolCertificado.length; i++) {
                  if (
                    json.data.tPolCertificado[i].TGmReclamoList != undefined
                  ) {
                    for (
                      var c = 0;
                      c < json.data.tPolCertificado[c].TGmReclamoList.length;
                      c++
                    ) {                      
                      //console.log(json.data.tPolCertificado[i].TGmReclamoList[c].TReclamo.idReclamo);
                      if (
                        $("#rec").val() ===
                        json.data.tPolCertificado[i].TGmReclamoList[c].TReclamo
                          .idReclamo
                      ) {
                        /*console.log(
                          "if:::" +
                            json.data.tPolCertificado[i].TGmReclamoList[c]
                              .TReclamo.idReclamo
                        );*/
                        valorValidado = 1;
                        /*console.log(
                          "encontrado" +
                            json.data.tPolCertificado[i].TGmReclamoList[c]
                              .TReclamo.idReclamo
                        );*/
                      } else {
                        /*console.log(
                          "else" +
                            json.data.tPolCertificado[i].TGmReclamoList[c]
                              .TReclamo.idReclamo
                        );*/
                        valorValidadoNo = 1;
                        /*console.log(
                          "no encontrado" +
                            json.data.tPolCertificado[i].TGmReclamoList[c]
                              .TReclamo.idReclamo
                        );*/
                      }
                    }
                  } else {
                    if (
                      json.data.tPolCertificado[i].TGmReclamoList != undefined
                    ) {
                      //console.log("ingrese a else" + i);
                      /*console.log(
                        json.data.tPolCertificado[i].TGmReclamoList.TReclamo
                          .idReclamo
                      );*/
                      if (
                        $("#rec").val() ===
                        json.data.tPolCertificado[i].TGmReclamoList.TReclamo
                          .idReclamo
                      ) {
                        valorValidado = 1;
                        /*console.log(
                          "encontrado" +
                            json.data.tPolCertificado[i].TGmReclamoList.TReclamo
                              .idReclamo
                        );*/
                      } else {
                        valorValidadoNo = 1;
                        /*console.log(
                          "no encontrado" +
                            json.data.tPolCertificado[i].TGmReclamoList.TReclamo
                              .idReclamo
                        );*/
                      }
                    }
                  }
                }
              } else {
                //console.log("else de prueba");
              }
              //console.log("valorValdiado" + valorValidado);
              if (valorValidado === 1 || window.consultar === "showHideDemo1") {
                //console.log("estoy en else");
                window.miVariable = json.data;
                setActive(active + 1);
              } else {
                setActive(active);
                swal({
                  title: "Importante",
                  text: "No puedes continuar con el proceso, el reclamo no existe.",
                  icon: "warning",
                  button: "OK!",
                });
              }
            } else if (window.consultar == "showHideDemo5") {
              //console.log($("#rec").val());
              //console.log("Pasa por aqui consulta: ");
              setModalInfo1($("#rec").val());              
              window.rectab = $("#rec").val();
              const idPoliza = sessionStorage.getItem("idPoliza");
              if (idPoliza) {
                axios
                  .get(
                    `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/usuario_reclamo/` +
                      idPoliza,
                    {
                      headers: {
                        Authorization: `Bearer ${sessionStorage.getItem(
                          "jwtToken"
                        )}`,
                      },
                    }
                  )
                  .then((json) => {
                    if (json.status === 200) {
                      //setdatoAsesor(json.data.contacto);
                      sessionStorage.setItem("datosAsesor", json.data.contacto);
                    } else {
                      swal("Error", "Validando informacion General", "warning");
                    }
                  })
                  .catch(function (error) {
                    swal(
                      "Error",
                      "Debes validar tu usuario y contraseña, si no cuentas con usuario puedes crearlo en la opción Crear Usuario",
                      "warning"
                    );
                  });
              }
              toogleTrueFalse5();
            } else {
              //console.log("else");
              window.miVariable = json.data;
              swal({
                title: "Exitoso",
                text: "Tu información ha sido confirmada, puedes proceder con tu gestión.",
                icon: "success",
                button: "OK!",
              });
              limpiar_spinner("dv_gmrec_blockgeneral");
              setActive(active + 1);
            }
          } else {
            swal(
              "Atención",
              "No se encontro información, revisa tus datos ó comunicate con tu asesor !!",
              "info"
            );
            limpiar_spinner("dv_gmrec_blockgeneral");
          }
        })
        .catch(function (error) {
          setLoading(false);
          swal(
            "Atención",
            "No se encontro información, revisa tus datos ó comunicate con tu asesor !!",
            "info"
          );
          limpiar_spinner("dv_gmrec_blockgeneral");
        });
    } else {
      swal("Atención", "Debes completar los datos para continuar!!", "warning");
      limpiar_spinner("dv_gmrec_blockgeneral");
      setLoading(false);
    }
  };

  //  const { showHideDemo1, showHideDemo2, showHideDemo3 } = '';
  const [active, setActive] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [selectedGestion, setSelectedGestion] = React.useState('');
  return (
    <Container>
      <input
        type="hidden"
        value=""
        id="val_creacion"
        name="val_creacion"
      ></input>

      <div className="digital-workflow">
      <MultiStepForm activeStep={active} accentColor="#0b5f96">
        <Step label={t("Inicio")}>
          <br></br>
          <h2>
            <strong
              style={{
                color: "#575a5d",
              }}
            >
              Gestiones
            </strong>
            <strong
              style={{
                color: "#003479",
              }}
            >
              Digitales
            </strong>
          </h2>

          <p>
            Con esta platafoma puedes dar tramite a tus autorizaciones y
            reclamos de Gastos Medicos, dar seguimiento y consultar desde
            cualquier dispositivo digital (Computadora, Tablet y celular).
          </p>
          <p>
            Solo debes de dar click en el boton SIGUIENTE que se encuentra en la
            parte inferior izquierda de la pantalla.
          </p>
          <p>
            <strong>IMPORTANTE:</strong>
            &nbsp; Puede adjuntar sus documentos en cualquiera de los siguientes
            formatos digitales: PDF, JPG, BMP, GIF , PNG, WORD, EXCEL
          </p>
          <p></p>
          <div align="center">
            <Carusel showThumbs={false} />
          </div>
          <hr
            style={{
              background: "#003479",
              color: "#003479",
              height: "3px",
            }}
          />
        </Step>
        <Step label={t("Ingresar")}>
          <Forms selectedGestion={selectedGestion} onGestionChange={setSelectedGestion} />
        </Step>
        <Step label={t("Acciones")}>
          {window.showHideDemo3 && <ModalContentBit />}
          {window.showHideDemo2 && <Parte2 />}
          {window.showHideDemo1 && <Parte1 />}
          <div
            id="dv_gmrec_blockgeneral"
            style={{
              display: "none",
            }}
          >
            <div
              style={{
                position: "tofixed",
                left: "50%",
                top: "50%",
              }}
            >
              <div>
                <div className="lockscreen-logo"></div>
                <div className="lockscreen-name"></div>
                <center>
                  <img src={loader} />
                </center>
                <div className="help-block text-center"></div>
                <div className="text-center"></div>
                <center>
                  <strong>Cargando información, espere un momento</strong>
                </center>
                <div className="lockscreen-footer text-center">
                  <strong>Copyright &copy; 2022</strong>
                  <strong>
                    <a href="http://somit.com" className="text-black">
                      Somit S.A
                    </a>
                    &nbsp; All rights reserved
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </Step>
      </MultiStepForm>
      </div>
      <br></br>
      {active !== 1 && (
        <Button onClick={() =>{ setActive(active - 1); window.showHideDemo2 = false;window.showHideDemo1 = false;}}>Regresar</Button>
      )}
      {active !== 2 && active !== 3 && (
        <Button
          onClick={() => setActive(active + 1)}
          style={{
            float: "right",
          }}
        >
          Siguiente
        </Button>
      )}
      {active == 2 && (
        <Button
          onClick={() => GetInfo()}
          style={{
            float: "right",
          }}
        >
          Siguiente
        </Button>
      )}
      <ModalContentLiq show={mostrarModalLiq} onClose={cerrarModalLiq} />
    </Container>
  );
};

export default General;
